var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v("Copyright © 2018-2019 Yi Group")])}
var staticRenderFns = []

export { render, staticRenderFns }